import React from "react";
import { NavLink } from "react-router-dom";

const NavigationLink = ({ filter, navLinkClicked, style, children, target }) => (
  <NavLink
    // exact
    // to={filter === 'SHOW_ALL' ? '/' : `/${filter}`}
    to={`/${filter}`}
    target={target ? "_blank" : ""}
    // activeStyle={{
    //   textDecoration: "none",
    //   color: "black",
    // }}
    style={style}
    className={"nav-link"}
    onClick={(e) => {
      console.log("navlink clickedksld fl");
      navLinkClicked();
    }}
  >
    {children}
  </NavLink>
);

export default NavigationLink;
